const DOUBLE_TAP_TIMEFRAME = 250;

const touchInfo = {
  lastTimeStamp: 0,
  touchCount: 0
};

export const handleDoubleTouch = (touchEvent, callback) => {

  const timeSinceLastTouch = touchEvent.timeStamp - touchInfo.lastTimeStamp;
  const touchLength = touchEvent.touches && touchEvent.touches.length ? touchEvent.touches.length : null;
  touchInfo.lastTimeStamp = touchEvent.timeStamp;
  
  touchInfo.touchCount++;

  if (timeSinceLastTouch < DOUBLE_TAP_TIMEFRAME && touchInfo.touchCount >= 2 && touchLength === 1) {      
    callback();
    touchInfo.touchCount = 0;
  }
}